import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
    Typography,
    Box,
} from '@mui/material';
import { CgCalendarDates } from 'react-icons/cg';
import { GrProjects } from 'react-icons/gr';
import CustomTextFieldWithIcon from '../../../../Components/custom_components/custom_text_field/CustomTextFieldWithIcon';
import CustomDatePicker from '../../../../Components/custom_components/CustomDatePicker/CustomDatePicker';
import dayjs from 'dayjs';
import { Grid } from '@mui/joy';
import ActionButton from '../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';



const HolidaySettings = ({ selectedEvent, handleSaveEvent, }) => {

    // Utility function to convert 'DD-MM-YYYY' to 'YYYY-MM-DD'
    const convertToISO = (dateStr) => {
        if (!dateStr || typeof dateStr !== 'string' || !dateStr.includes('-')) return null;

        const [day, month, year] = dateStr.split('-');
        if (!day || !month || !year) return null;

        return `${year}-${month}-${day}`;
    };

    const validationSchema = Yup.object().shape({
        title: Yup.string()
            .required('Title is required')
            .max(20, 'Title must be at most 20 characters'),
        startDate: Yup.string()
            .required('Survey From Date is required'),

        endDate: Yup.string()
            .required('Survey To Date is required')
            .test(
                'end-date-after-start-date',
                'End date cannot be before start date',
                function (value) {
                    const { startDate } = this.parent;

                    const start_Date = new Date(convertToISO(startDate) || '');
                    const endDate = new Date(convertToISO(value) || '');
                    return endDate >= start_Date;
                }
            ),
    });

    const formik = useFormik({
        initialValues: {
            title: selectedEvent?.title || "",
            startDate: selectedEvent?.startDate || "",
            endDate: selectedEvent?.endDate || "",
            HD_Status: 1, //active by default
        },
        validationSchema,
        onSubmit: (values) => {
            handleSaveEvent({
                id: selectedEvent?.id, //Date.now(),
                title: values.title,
                start: dayjs(values.startDate, "DD-MM-YYYY").format("YYYY-MM-DD"),
                end: dayjs(values.endDate, "DD-MM-YYYY").format("YYYY-MM-DD"), // Add 1 day to include the selected end date
                HD_Status: 1,
            });

        }
    });

    return (
        <Box className="mt-3">
            <Grid container spacing={2}>
                {!formik.values.isWeekend && (
                    <>
                        <Grid item xs={12} sm={12}>
                            <Typography variant="body1" className="label">Holiday Title <span className='label_required_remark'>*</span></Typography>
                            <CustomTextFieldWithIcon
                                id="title"
                                name="title"
                                placeholder="Enter title"
                                value={formik.values.title}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.title && Boolean(formik.errors.title)}
                                helperText={formik.touched.title && formik.errors.title}
                                StartIcon={GrProjects}
                                isDisabled={false}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="body1" className="label">Start Date <span className='label_required_remark'>*</span></Typography>

                            <CustomDatePicker
                                name="startDate"
                                value={dayjs(formik.values.startDate, "DD-MM-YYYY")}
                                onChange={(date) => formik.setFieldValue("startDate", date)}
                                onBlur={formik.handleBlur}
                                StartIcon={CgCalendarDates}
                                isDisabled={false}
                                error={formik.touched.startDate && Boolean(formik.errors.startDate)}
                                helperText={formik.touched.startDate && formik.errors.startDate}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="body1" className="label">End Date <span className='label_required_remark'>*</span></Typography>
                            <CustomDatePicker
                                name="endDate"
                                value={dayjs(formik.values.endDate, "DD-MM-YYYY")}
                                onChange={(date) => formik.setFieldValue("endDate", date)}
                                onBlur={formik.handleBlur}

                                StartIcon={CgCalendarDates}
                                isDisabled={false}
                                error={formik.touched.endDate && Boolean(formik.errors.endDate)}
                                helperText={formik.touched.endDate && formik.errors.endDate}

                            />
                        </Grid>
                    </>
                )}
            </Grid>

            <div className='form-bottom-action-buttons-container'>
                <ActionButton
                    onClick={formik.handleSubmit}
                    btnDisable={false}
                    label='Save'
                    btnType='primary'
                />
            </div>
        </Box>
    );
};

export default HolidaySettings;